import { Drawer, Icon, LabeledValue, Layout } from '@loadsmart/miranda-react'

export function Scheduled({ onReschedule }: { onReschedule: () => void }) {
  return (
    <>
      <Drawer.Header>
        <Layout.Group align="center" gap="spacing-1">
          <Icon name="calendar" size="24px" />
          Scheduled
        </Layout.Group>
        <Drawer.Close />
      </Drawer.Header>
      <Drawer.Body>
        <Layout.Stack gap="spacing-4">
          <LabeledValue>
            <LabeledValue.Label>Warehouse</LabeledValue.Label>
            <LabeledValue.Value>abc</LabeledValue.Value>
          </LabeledValue>
          <LabeledValue>
            <LabeledValue.Label>Load type</LabeledValue.Label>
            <LabeledValue.Value>bbb</LabeledValue.Value>
          </LabeledValue>
          <LabeledValue>
            <LabeledValue.Label>Dock</LabeledValue.Label>
            <LabeledValue.Value>ccc</LabeledValue.Value>
          </LabeledValue>
          <LabeledValue>
            <LabeledValue.Label>Scheduled At</LabeledValue.Label>
            <LabeledValue.Value>ddd</LabeledValue.Value>
          </LabeledValue>
        </Layout.Stack>
      </Drawer.Body>
      <Drawer.Actions>
        <Drawer.ActionTertiary style={{ marginRight: 'auto' }}>
          Cancel appointment
        </Drawer.ActionTertiary>
        <Drawer.ActionPrimary onClick={onReschedule}>Reschedule</Drawer.ActionPrimary>
      </Drawer.Actions>
    </>
  )
}
